import {
  DeleteCustomerCommunication,
  deleteCustomerPrices,
  getPrintingMachineType,
  getCustomerStatusType,
  getCustomerReceiveFileType,
  getSaleExpert,
  getAllDesigners,
  getCustomerGradeType,
  getCustomerDeliverType,
  getCustomerDeliverMethod,
  getDeptCollectors,
  getAllCustomers,
  getSingleCustomer,
  addCustomer,
  getSingleCustomerData,
  getRegisterationPrices,
  deleteCustomerMachine,
  deleteCustomerSendInfo,
  deleteCustomerAniloxe,
  deleteCustomerCylinder,
  editCustomer,
  getCustomerWorkBranch,
  deleteCustomer,
  getAllDpi,
  getLpi,
  getMachineProfile,
  deleteMachineDpiLpi,
  getKlischeTypeCategory,
  getKlischeThinknessByCategoryId,
  getCollectionClaims,
  getCustomerDetailGroup,
  GetAllBatizCustomers,
  validateCustomerAccountingCode,
  GetAllCustomerQCTypes,
  DeleteCustomerPriceHistory,
  GetAgingReport,
  GetCustomerFilters,
  GetCustomerDebtLetter,
  SaveDebtLetter,
  GetCustomerDebtLetters,
  GetDebtLetterById
} from "../Api/Index";
import { customApi } from "../../../CustomHoock/CustomApi";
// import customeap
import { getOrderTotalR } from "../../../General/Store/GeneralSlice";
import { getAllCustomersNameForOrder } from "../../Orders/Api/index";

import { useQuery, useMutation, useQueryClient } from "react-query";
import {
  setSingleCustomerDataR,
  setErrorsR,
  setSingleCustomerDataForEditR,
  setAllPricesR,
} from "../SaleSlice/SaleSlice";
import { useDispatch } from "react-redux";
import { useSnackbar } from "notistack";
import Snackbar from "@mui/material/Snackbar";
import { useNavigate } from "react-router-dom";

const useAddCustomer = (onSuccessDon, failSend) => {
  const navigate = useNavigate();
  const queryClient = useQueryClient();
  const dispatch = useDispatch();
  return useMutation({
    mutationFn: (data) => addCustomer(data),
    onSuccess: (data) => {
      queryClient.invalidateQueries("getAllCustomers");
      onSuccessDon();
    },

    onError: (data) => {
      failSend();
      let rawData =
        data?.response?.data?.resourceKeyResult?.resourceKeyList[0]
          ?.resourceKeys[0];
      dispatch(setErrorsR(rawData));
    },
  });
};

const useGetAllCustomers = (getCustomerBody) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  return useQuery(["getAllCustomers", getCustomerBody], getAllCustomers, {
    enabled: !!getCustomerBody,
    refetchOnWindowFocus: false,
    refetchOnMount: false,
    cacheTime: Infinity,
    onSuccess: (data) => { },
    onError: (err) => {
      // navigate("/", { replace: true });
    },
    select: (data) => {
      dispatch(getOrderTotalR(data?.data.totalRecord));
      let rawData = data?.data;
      return rawData;
    },
  });
};

const useDeleteCustomer = (deleteCustomerSuccess, deleteCustomerFailed) => {
  const navigate = useNavigate();
  const queryClient = useQueryClient();
  return useMutation(deleteCustomer, {
    onSuccess: (data) => {
      queryClient.invalidateQueries("getAllCustomers");
      deleteCustomerSuccess();
    },
    onError: (err) => {
      deleteCustomerFailed();
    },
  });
};

const useGetSingleCustomerDataForEdit = (onSuccess, onError) => {
  const navigate = useNavigate();
  // setSingleCustomerDataForEditR
  const dispatch = useDispatch();
  return useMutation(getSingleCustomerData, {
    onSuccess: (data) => {
      // console.log(data)
      let rawData = data?.data.data;
      dispatch(setSingleCustomerDataForEditR(rawData));
    },
    onError: (err) => {
      onError();
      // navigate("/", { replace: true });
    },
  });
};

// const useEditCustomer=(editCustomerSucces,editCustomerFailed)=>{
//     const navigate=useNavigate();
//     const queryClient=useQueryClient();
//     return useMutation(editCustomer,{
//         onSuccess:()=>{
//             editCustomerSucces()
//             queryClient.invalidateQueries('getAllCustomers')
//         }
//         ,
//         onError:(err)=>{

//             editCustomerFailed()
//         }
//     })
// }

const useEditCustomer = (editCustomerSucces, editCustomerFailed) => {
  const navigate = useNavigate();
  const queryClient = useQueryClient();
  const dispatch = useDispatch();
  return useMutation({
    mutationFn: (data) => editCustomer(data),
    onSuccess: (data) => {
      queryClient.invalidateQueries("getAllCustomers");
      editCustomerSucces();
    },

    onError: (data) => {
      //    console.log(data)
      let rawData =
        data?.response?.data?.resourceKeyResult?.resourceKeyList[0]
          ?.resourceKeys[0];
      //    console.log(rawData)
      dispatch(setErrorsR(rawData));

      setTimeout(() => {
        dispatch(setErrorsR(""));
      }, 4000);

      editCustomerFailed();
    },
  });
};

const useDeleteCustomerCommunication = (
  deleteCommunicationSuccess,
  deleteCommunicationFailed,
) => {
  const navigate = useNavigate();
  return useMutation(DeleteCustomerCommunication, {
    onSuccess: () => {
      deleteCommunicationSuccess();
    },
    onError: () => {
      deleteCommunicationFailed();
      // navigate("/", { replace: true });
    },
  });
};

// const useDeleteCustomerPrices=(Success,deletePriceOnFailed)=>{
//     const navigate=useNavigate();
//     const queryClient=useQueryClient();
//     return useMutation(deleteCustomerPrices,{
//         onSuccess:()=>{
//             Success()
//         // queryClient.invalidateQueries('getCostumer')
//         }
//         ,
//         onError:()=>{
//             deletePriceOnFailed()
//             // navigate("/", { replace: true });
//         }
//     })
// }

const useDeleteCustomerPrices = (Success, deletePriceOnFailed) => {
  const dispatch = useDispatch();
  return useMutation({
    mutationFn: (data) => deleteCustomerPrices(data),
    onSuccess: (data) => {
      Success();
    },

    onError: (data) => {
      let rawData =
        data?.response?.data?.resourceKeyResult?.resourceKeyList[0]
          ?.resourceKeys[0];
      deletePriceOnFailed();
      // console.log(rawData);

      dispatch(setErrorsR(rawData));

      setTimeout(() => {
        dispatch(setErrorsR(""));
      }, 20000);
    },
  });
};

const useGetPrintingMachineType = () => {
  const navigate = useNavigate();
  return useQuery(["getPrintingMachineType"], getPrintingMachineType, {
    cacheTime: 500000,
    staleTime: 600000,
    onSuccess: () => {
      // console.log("getPrintingMachineType Sucessss");
    },
    onError: () => {
      navigate("/", { replace: true });
    },
    select: (data) => {
      const PrintingMachineType = data?.data.data.map((machineType) => {
        return { key: machineType.machineTypeName, value: machineType.id };
      });
      return PrintingMachineType;
    },
  });
};

const useGetCustomerStatusType = () => {
  const navigate = useNavigate();
  return useQuery(["getCustomerStatusType"], getCustomerStatusType, {
    refetchOnWindowFocus: false,
    onSuccess: () => {
      // console.log("useGetCustomerStatusType Success..!!!");
    },
    onError: () => {
      navigate("/", { replace: true });
    },
    select: (data) => {
      let customerStatusType = data?.data.data;
      const customerStatusData = customerStatusType.map((staus) => {
        return { key: staus.statusType, value: staus.id };
      });
      return customerStatusData;
    },
  });
};

const useGetCustomerReceiveFileType = (customerReceivedFileTypeId) => {
  const navigate = useNavigate();
  return useQuery(["getCustomerReceiveFileType"], getCustomerReceiveFileType, {
    // enabled:!!customerReceivedFileTypeId,
    refetchOnWindowFocus: false,
    cacheTime: Infinity,
    onSuccess: () => {
      //  console.log('getCustomerReceiveFileType Success..!!!')
    },
    onError: () => {
      navigate("/", { replace: true });
    },
    select: (data) => {
      let receiveFileTypeRaw = data?.data.data;
      const receiveFileType = receiveFileTypeRaw.map((recFile) => {
        return { key: recFile.receivedFileType, value: recFile.id };
      });
      return receiveFileType;
    },
  });
};

//  getOrdersUnitUsers

const useGetCustomerGradeType = () => {
  const navigate = useNavigate();
  return useQuery(["getCustomerGradeType"], getCustomerGradeType, {
    refetchOnWindowFocus: false,
    onSuccess: () => {
      // console.log("getCustomerGradeType Succes..!!!");
    },
    onError: () => {
      navigate("/", { replace: true });
    },
    select: (data) => {
      let customerGradeTypeRaw = data?.data.data;
      let customerGradeTypes = customerGradeTypeRaw.map((gradeTypes) => {
        return { key: gradeTypes.gradeName, value: gradeTypes.id };
      });

      return customerGradeTypes;
    },
  });
};

const useGetSaleExpert = () => {
  const navigate = useNavigate();
  return useQuery("getSaleExpert", getSaleExpert, {
    refetchOnWindowFocus: false,
    cacheTime: Infinity,

    onSuccess: (data) => {
      // console.log("getSaleExpert Success..!!!");
    },
    onError: () => {
      navigate("/", { replace: true });
    },
    select: (data) => {
      let designExpertsRaw = data?.data.data;
      let designExperts = designExpertsRaw.map((expert) => {
        return { key: expert.fullName, value: expert.id };
      });

      return designExperts;
    },
  });
};

const useGetAllDesigners = () => {
  const navigate = useNavigate();
  return useQuery("getAllDesigners", getAllDesigners, {
    refetchOnWindowFocus: false,
    cacheTime: Infinity,
    onSuccess: (data) => {
      // console.log("getAllDesigners Success..!!!");
    },
    onError: () => {
      // navigate("/", { replace: true });
    },
    select: (data) => {
      let OrderExpertsRaw = data?.data.data;
      let OrderExperts = OrderExpertsRaw.map((expert) => {
        return { key: expert.fullName, value: expert.id };
      });

      return OrderExperts;
    },
  });
};

const useGetDeptCollectors = () => {
  const navigate = useNavigate();
  return useQuery(["getDeptCollector"], getDeptCollectors, {
    refetchOnWindowFocus: false,
    cacheTime: Infinity,
    onError: () => {
      navigate("/", { replace: true });
    },
    onSuccess: () => {
      // console.log("getDeptCollector Success..!!!");
    },
    select: (data) => {
      let rawData = data?.data.data;
      let deptCollectors = rawData.map((collector) => {
        return { key: collector.fullName, value: collector.id };
      });
      return deptCollectors;
    },
  });
};

const useGetCustomerDeliverType = (id) => {
  const navigate = useNavigate();
  return useQuery(["getCustomerDeliverType", id], getCustomerDeliverType, {
    refetchOnWindowFocus: false,
    enabled: !!id,
    cacheTime: Infinity,
    onError: () => {
      //  navigate("/", { replace: true });
    },
    onSuccess: () => {
      // console.log("getCustomerDeliverType Success..!!!");
    },
    select: (data) => {
      let deliverTypesRaw = data?.data.data;
      let deliverTypes = deliverTypesRaw.map((typ) => {
        return { key: typ.title, value: typ.id };
      });
      return deliverTypes;
    },
  });
};

const useGetcustomerDeliverMethod = (id) => {
  const navigate = useNavigate();
  return useQuery(["getCustomerDeliverMethod", id], getCustomerDeliverMethod, {
    refetchOnWindowFocus: false,
    enabled: !!id,
    cacheTime: Infinity,
    onSuccess: (data) => {
      // console.log(data);
    },
    onError: () => {
      navigate("/", { replace: true });
    },
    select: (data) => {
      let methodTypeDataRaw = data?.data.data;
      // console.log(methodTypeDataRaw)
      let methodTypesData = methodTypeDataRaw.map((typ) => {
        return { key: typ.title, value: typ.id };
      });
      return methodTypesData;
    },
  });
};

/**==============================================
 *                Customer View Api
 *
 *
 *
 *
 *=============================================**/
const useGetSingleCustomer = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  return useMutation(getSingleCustomer, {
    onSuccess: (data) => {
      let rawData = data?.data.data;
      dispatch(setSingleCustomerDataR(rawData));
    },
    onError: (err) => {
      // console.log(err);
      // navigate("/", { replace: true });
    },
  });
};

const useGetRegistrationPrices = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  return useQuery(["getRegistrationPrices"], getRegisterationPrices, {
    enabled: false,
    onSuccess: (data) => {
      // console.log(data);
    },
    onError: () => {
      //   console.log('get klische price Error')
      navigate("/", { replace: true });
    },
    select: (data) => {
      let rawData = data?.data.data;
      dispatch(setAllPricesR(rawData));
      //  console.log(rawData)

      return rawData;
    },
  });
};

const useDeleteCustomerMachine = (
  deleteMachineSuccess,
  deleteMachineFailed,
) => {
  // const navigate=useNavigate();
  return useMutation(deleteCustomerMachine, {
    onSuccess: (data) => {
      // console.log(data);
      deleteMachineSuccess();
    },
    onError: (err) => {
      // deleteFailed()
      // navigate("/", { replace: true });
      deleteMachineFailed();
    },
  });
};

const useDeleteCustomerSendInfo = (
  deleteCustomerSendIndoSuccess,
  deleteCustomerSendInfoFailed,
) => {
  const navigate = useNavigate();
  return useMutation(deleteCustomerSendInfo, {
    onSuccess: () => {
      deleteCustomerSendIndoSuccess();
    },
    onError: () => {
      deleteCustomerSendInfoFailed();
      // navigate("/", { replace: true });
    },
  });
};

const useDeleteCustomerAniloxe = (
  AniloxeDeleteSuccess,
  AniloxeDeleteFailed,
) => {
  const navigate = useNavigate();
  return useMutation(deleteCustomerAniloxe, {
    onSuccess: (data) => {
      AniloxeDeleteSuccess();
    },
    onError: (err) => {
      AniloxeDeleteFailed();
      navigate("/", { replace: true });
    },
  });
};

const useDeleteCustomerCylinder = (
  cylinderDeleteSuccess,
  cylinderDeleteFailed,
) => {
  const navigate = useNavigate();
  return useMutation(deleteCustomerCylinder, {
    onSuccess: (data) => {
      // console.log(data);
      cylinderDeleteSuccess();
    },
    onError: (err) => {
      cylinderDeleteFailed();
      navigate("/", { replace: true });
    },
  });
};

const useGetCustomerWorkBranch = () => {
  const navigate = useNavigate();
  return useQuery(["getCustomerWorkBranch"], getCustomerWorkBranch, {
    refetchOnWindowFocus: false,
    cacheTime: Infinity,
    onSuccess: (data) => { },
    onError: (err) => {
      navigate("/", { replace: true });
    },
    select: (data) => {
      let rawData = data?.data.data;
      let readyData = rawData.map((data) => {
        return { key: data.workBranchName, value: data.id };
      });
      return readyData;
    },
  });
};

const useGetAllDpi = () => {
  const navigate = useNavigate();
  return useQuery(["getAllDpi"], getAllDpi, {
    refetchOnWindowFocus: false,
    cacheTime: Infinity,
    onError: (err) => {
      navigate("/", { replace: true });
    },
    select: (data) => {
      let rawData = data?.data.data;
      let readyData = rawData.map((dpi) => {
        return { key: dpi.dpi, value: dpi.id };
      });
      return readyData;
    },
  });
};

const useGetLpi = (id) => {
  // console.log(id)
  const navigate = useNavigate();
  return useQuery(["getLpi", id], getLpi, {
    refetchOnWindowFocus: false,
    cacheTime: Infinity,
    enabled: !!id,
    onError: (err) => {
      navigate("/", { replace: true });
    },
    select: (data) => {
      let rawData = data?.data.data;
      let readyData = rawData.map((lpi) => {
        return { key: lpi.lpi, value: lpi.id };
      });
      return readyData;
    },
  });
};

const useGetMachineProfile = () => {
  const navigate = useNavigate();
  return useQuery(["getMachineProfile"], getMachineProfile, {
    refetchOnWindowFocus: false,
    cacheTime: Infinity,
    onError: (err) => {
      navigate("/", { replace: true });
    },
    select: (data) => {
      let rawData = data?.data.data;
      let readyData = rawData.map((profile) => {
        return { key: profile.profileName, value: profile.id };
      });
      return readyData;
    },
  });
};

const useDeleteMachineDpiLpi = (dpiDeleteSuccess, dpiDeleteFailedd) => {
  return useMutation(deleteMachineDpiLpi, {
    onSuccess: (data) => {
      // console.log(data);
      dpiDeleteSuccess();
    },
    onError: (err) => {
      dpiDeleteFailedd();
    },
  });
};

// http://192.168.3.17:81/GetKlischeTypeCategory

// const useGetKlischeTypeCategory=()=>{
// return useQuery({})
// }

const useGetKlischeTypeCategory = (reqUnitsBody) => {
  return useQuery(["GetKlischeTypeCategory"], getKlischeTypeCategory, {
    enabled: true,
    refetchOnWindowFocus: false,
    onSuccess: (data) => {
      // console.log(data)
      return data;
    },
    onError: (err) => {
      // console.log(err);
    },
    select: (data) => {
      let rawData = data?.data.data;
      let transFormed = rawData.map(({ categoryName: key, id: value }) => {
        return { key, value };
      });
      return transFormed;
    },
  });
};

const useGetKlischeThinknessByCategoryId = (categoryId) => {
  return useQuery(
    ["getKlischeThinknessByCategoryId", categoryId],
    getKlischeThinknessByCategoryId,
    {
      refetchOnWindowFocus: false,
      enabled: !!categoryId,
      // cacheTime:i
      select: (data) => {
        let rawData = data?.data?.data;
        let transFormed = rawData?.map(({ thickness: key, id: value }) => {
          return { key, value };
        });
        return transFormed;
      },
      onError: (err) => {
        // console.log(err);
      },
    },
  );
};

//   getCollectionClaims

const useGetCollectionClaims = () => {
  const navigate = useNavigate();
  return useQuery(["GetCollectionClaims"], getCollectionClaims, {
    refetchOnWindowFocus: false,
    cacheTime: Infinity,
    refetchOnMount: false,
    onError: () => {
      navigate("/", { replace: true });
    },
    onSuccess: () => {
      // console.log("GetCollectionClaims Success..!!!");
    },
    select: (data) => {
      let rawData = data?.data.data;
      let collectionClaims = rawData.map((collector) => {
        return { key: collector.fullName, value: collector.id };
      });
      return collectionClaims;
    },
  });
};
// getCustomerDetailGroup

const useGetCustomerDetailGroup = () => {
  const navigate = useNavigate();
  return useQuery(["GetCustomerDetailGroup"], getCustomerDetailGroup, {
    refetchOnWindowFocus: false,
    cacheTime: Infinity,
    refetchOnMount: false,
    onError: () => {
      // navigate("/", { replace: true });
    },
    onSuccess: () => {
      // console.log("GetCollectionClaims Success..!!!");
    },
    select: (data) => {
      let rawData = data?.data.data;

      return rawData;
    },
  });
};

const useGetCustomersNames = () => {
  // const navigate=useNavigate();
  return useQuery(["getCustomersNames"], getAllCustomersNameForOrder, {
    refetchOnWindowFocus: false,
    cacheTime: Infinity,
    refetchOnMount: false,
    onError: () => {
      // navigate("/", { replace: true });
    },
    onSuccess: () => {
      // console.log("GetCollectionClaims Success..!!!");
    },
    select: (data) => {
      let rawData = data?.data.data;
      let readyData = rawData.map(({ fullName, id }) => {
        return { key: fullName, value: id };
      });
      return readyData;
    },
  });
};
export const useAddChangePriceLetter = (setOpen) => {
  return useMutation(
    (body) =>
      customApi({
        apiType: "post",
        url: `/api/v1/ChangePriceLetter/AddChangePriceLetter`,
        reactQuery: "mutate",
        requestBody: body,
      }),
    {},
  );
};
export const useEditChangePriceLetter = (setOpen) => {
  return useMutation(
    (body) =>
      customApi({
        apiType: "post",
        url: `/api/v1/ChangePriceLetter/UpdateChangePriceLetter`,
        reactQuery: "mutate",
        requestBody: body,
      }),
    {},
  );
};
const useGetAllBatizCustomers = () => {
  const navigate = useNavigate();
  return useQuery(["GetAllBatizCustomers"], GetAllBatizCustomers, {
    refetchOnWindowFocus: false,
    // cacheTime: Infinity,
    // refetchOnMount: false,
    onError: () => {
      // navigate("/", { replace: true });
    },
    onSuccess: () => {
      // console.log("GetCollectionClaims Success..!!!");
    },
    select: (data) => {
      const rawData = data?.data?.data ?? [];

      if (!Array.isArray(rawData) || rawData.length === 0) {
        return [];
      }

      return rawData;
    },
  });
};
// validateCustomerAccountingCode

const useValidateCustomerAccountingCode = (code) => {
  console.log(code);
  return useQuery(
    ["validateCustomerAccountingCode", code],
    validateCustomerAccountingCode,
    {
      enabled: !!code,
      refetchOnWindowFocus: false,
      cacheTime: Infinity,
      onError: () => {
        // navigate("/", { replace: true });
      },
      onSuccess: () => {
        // console.log("GetCollectionClaims Success..!!!");
      },
      select: (data) => {
        const rawData = data?.data?.data;
        return rawData;
      },
    },
  );
};

// GetAllCustomerQCTypes
const useGetAllCustomerQCTypese = () => {
  //  console.log(code)
  return useQuery(["GetAllCustomerQCTypes"], GetAllCustomerQCTypes, {
    enabled: true,
    refetchOnWindowFocus: false,
    cacheTime: Infinity,
    onError: () => {
      // navigate("/", { replace: true });
    },
    onSuccess: () => {
      // console.log("GetCollectionClaims Success..!!!");
    },
    select: (data) => {
      const rawData = data?.data?.data;
      return rawData;
    },
  });
};
// DeleteCustomerPriceHistory

const useDeleteCustomerPriceHistory = (afterDeleteSuccess, afterFailed) => {
  const queryClient = useQueryClient();
  return useMutation(DeleteCustomerPriceHistory, {
    onSuccess: (data) => {
      afterDeleteSuccess();
      // queryClient.invalidateQueries("GetKlischePriceHistoryById");
    },
    onError: (err) => {
      afterFailed();
    },
  });
};

// GetAllCustomerQCTypes
const useGetAgingReport = (body) => {
  //  console.log(code)
  return useQuery(["GetAgingReport", body], GetAgingReport, {
    enabled: !!body,
    refetchOnWindowFocus: false,
    cacheTime: Infinity,
    onError: () => {
      // navigate("/", { replace: true });
    },
    onSuccess: () => {
      // console.log("GetCollectionClaims Success..!!!");
    },
    select: (data) => {
      const rawData = data?.data?.data;
      return rawData;
    },
  });
};

const useGetCustomerFilters = (body) => {
  return useQuery(["GetCustomerFilters"], GetCustomerFilters, {
    enabled: true,
    refetchOnWindowFocus: false,
    cacheTime: Infinity,
    onError: () => {
      // navigate("/", { replace: true });
    },
    onSuccess: () => {
      // console.log("GetCollectionClaims Success..!!!");
    },
    select: (data) => {
      const rawData = data?.data?.data;
      return rawData;
    },
  });
};

const useGetCustomerDebtLetter = () => {

  return useMutation(GetCustomerDebtLetter, {
    onSuccess: (data) => {

    },
    onError: (err) => {
      // afterFailed();
    },
  });
};
//  SaveDebtLetter



const useGetCustomerDebtLetters = (customerId) => {
  return useQuery(["GetCustomerDebtLetters", customerId], GetCustomerDebtLetters, {
    enabled: !!customerId,
    refetchOnWindowFocus: false,
    cacheTime: Infinity,
    onError: () => {
      // navigate("/", { replace: true });
    },
    onSuccess: () => {
      // console.log("GetCollectionClaims Success..!!!");
    },
    select: (data) => {
      const rawData = data?.data?.data;
      return rawData;
    },
  });
};

const useGetDebtLetterById = (id) => {
  return useQuery(["GetDebtLetterById", id], GetDebtLetterById, {
    enabled: !!id,
    refetchOnWindowFocus: false,
    cacheTime: Infinity,
    onError: () => {
      // navigate("/", { replace: true });
    },
    onSuccess: () => {
      // console.log("GetCollectionClaims Success..!!!");
    },
    select: (data) => {
      const rawData = data?.data?.data;
      return rawData;
    },
  });
};
const useSaveDebtLetter = (success,failed) => {
  const queryClient = useQueryClient();

  return useMutation(SaveDebtLetter, {
    onSuccess: (data) => {
      queryClient.invalidateQueries('GetCustomerDebtLetters');  
      success()
    },
    onError: (err) => {
      // afterFailed();
    },
  });
};

// GetDebtLetterById





export {
  useDeleteCustomerCommunication,
  useDeleteCustomerPrices,
  useGetPrintingMachineType,
  useGetCustomerStatusType,
  useGetCustomerReceiveFileType,
  useGetAllDesigners,
  useGetSaleExpert,
  useGetCustomerGradeType,
  useGetCustomerDeliverType,
  useGetcustomerDeliverMethod,
  useGetDeptCollectors,
  useGetAllCustomers,
  useGetSingleCustomer,
  useAddCustomer,
  useDeleteCustomer,
  useGetSingleCustomerDataForEdit,
  useGetRegistrationPrices,
  useDeleteCustomerMachine,
  useDeleteCustomerSendInfo,
  useDeleteCustomerAniloxe,
  useDeleteCustomerCylinder,
  useEditCustomer,
  useGetCustomerWorkBranch,
  useGetAllDpi,
  useGetLpi,
  useGetMachineProfile,
  useDeleteMachineDpiLpi,
  useGetKlischeTypeCategory,
  useGetKlischeThinknessByCategoryId,
  useGetCollectionClaims,
  useGetCustomerDetailGroup,
  useGetCustomersNames,
  useGetAllBatizCustomers,
  useValidateCustomerAccountingCode,
  useGetAllCustomerQCTypese,
  useDeleteCustomerPriceHistory,
  useGetAgingReport,
  useGetCustomerFilters,
  useGetCustomerDebtLetter,
  useSaveDebtLetter,
  useGetCustomerDebtLetters,
  useGetDebtLetterById
};
